import ReactDOM from "react-dom";

//Test for env in here, using the .env files.
//const env =  process.env.NODE_ENV === 'production'


export const
    render = ReactDOM.render || ReactDOM.hydrate;